import { assertPartialSchema, createAction, useSelector, v } from "../../../lib";
import { DB_NAME, DbOperationResult } from "../../db";
import { DailyDataType } from "../../db/db_data_setter";

export enum ParticipantDailyDataActionType {
  HANDLE_PARTICIPANT_DAILY_DATA_DB_RESULT = "HANDLE_PARTICIPANT_DAILY_SUMMARY_DATA_DB_RESULT",
}

export const doHANDLE_PARTICIPANT_DAILY_DATA_DB_RESULT = createAction(
  ParticipantDailyDataActionType.HANDLE_PARTICIPANT_DAILY_DATA_DB_RESULT,
);

export type dateDataState = Record<number, boolean>;
export type TypeDataDateState = Record<string, dateDataState>;

export interface ParticipantDailyData {
  [participantId: string]: TypeDataDateState;
}

interface RootState {
  participantDailyData: ParticipantDailyData;
}
/* selector */
export const useSelectParticipantDailyData = (participantId: string) => {
  return useSelector((state: RootState) => state.participantDailyData[participantId]);
};

export const handleParticipantDailyDataDbResultActionCreators = {
  doHANDLE_PARTICIPANT_DAILY_DATA_DB_RESULT,
};

export const participantDailyDataDefaultState: ParticipantDailyData = {};

type Action = {
  type: ParticipantDailyDataActionType.HANDLE_PARTICIPANT_DAILY_DATA_DB_RESULT;
  payload: {
    dbOperationResultList: DbOperationResult<DailyDataType>[];
  };
};

export const participantDailyDataReducer = (
  state: ParticipantDailyData = participantDailyDataDefaultState,
  { type, payload }: Action,
) => {
  switch (type) {
    case ParticipantDailyDataActionType.HANDLE_PARTICIPANT_DAILY_DATA_DB_RESULT: {
      assertPartialSchema({
        payload,
        schema: v.object({
          dbOperationResultList: v.array().items(
            v.object({
              dbName: v.string().required(),
              participantId: v.string().uuid().required(),
              dataType: v.string().required(),
              yymmddIndex: v.number().required(),
              operation: v.string().required(),
              result: v.bool().required(),
            }),
          ),
        }),
      });
      const { dbOperationResultList } = payload;
      const newParticipantState: { [participantId: string]: TypeDataDateState } = {};
      dbOperationResultList.forEach((dbResult) => {
        const { dbName, participantId, dataType, yymmddIndex, result } = dbResult;
        if (dbName == DB_NAME.DailyData) {
          if (!newParticipantState[participantId]) {
            newParticipantState[participantId] = {};
          }

          const participantDataState = newParticipantState[participantId];
          if (dataType) {
            if (!participantDataState[dataType]) {
              participantDataState[dataType] = { [yymmddIndex]: result };
            } else {
              participantDataState[dataType] = {
                ...participantDataState[dataType],
                [yymmddIndex]: result,
              };
            }
          }
        }
      });

      let nextState = state;
      for (const [participantId, dataState] of Object.entries(newParticipantState)) {
        if (nextState === state) {
          nextState = { ...state };
        }

        if (!state[participantId]) {
          nextState[participantId] = dataState;
        } else {
          const nextParticipantState = { ...state[participantId] };
          for (const [dataType, yymmddState] of Object.entries(dataState)) {
            nextParticipantState[dataType] = {
              ...nextParticipantState[dataType],
              ...yymmddState,
            };
          }
          nextState[participantId] = nextParticipantState;
        }
      }

      return nextState;
    }
    default:
      return state;
  }
};
